import React, { useState, useRef, useEffect } from "react";
import {
  DownArrowIcon,
  SearchIcons,
  EmptyCurrencyListIcons,
} from "../../Icons";
import LoadingSpinner from "../../Icons/LoadingSpinner";

const CommonDropdown = ({
  options = [],
  value,
  onChange,
  label,
  placeholder = "Select",
  searchable = true,
  showIcon = false,
  isLoading = false,
  error,
  className = "",
  readOnly = false,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  const selectedOption = options.find((opt) => opt.id === value?.id);

  const filteredOptions = options.filter((opt) =>
    opt.label.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const handleSelect = (option) => {
    if (readOnly) return;

    onChange(option);
    setIsOpen(false);
    setSearchQuery("");
  };

  const toggleDropdown = () => {
    if (readOnly) return;
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      {/* Input */}
      <div
        onClick={toggleDropdown}
        className={`shadow-sm rounded-xl flex justify-between items-center py-1.5 px-3
        ${readOnly ? "form-input-field-wrapper-readonly cursor-not-allowed opacity-70" : "cursor-pointer"}
        ${error ? "select-input-error" : "select-input-default"}`}
      >
        <div className="flex flex-col w-full">
          {label && (
            <span className="text-xs font-medium select-input-lable py-1">
              {label}
            </span>
          )}

          {selectedOption ? (
            <div className="flex items-center space-x-2">
              {showIcon && selectedOption.icon && (
                <img
                  src={selectedOption.icon}
                  alt=""
                  className="w-6 h-6 rounded-full"
                />
              )}

              <span className="!text-xs font-medium common-lable">
                {selectedOption.label}
              </span>
            </div>
          ) : isLoading ? (
            <span className="flex items-center common-lable">
              <LoadingSpinner /> loading...
            </span>
          ) : (
            <span className="!text-xs select-input-placeholder">
              {placeholder}
            </span>
          )}
        </div>

        <DownArrowIcon className={`w-4 h-4 ${readOnly ? "opacity-50" : ""}`} />
      </div>

      {/* Dropdown */}
      {!readOnly && (
        <div
          className={`absolute z-10 w-[340px] md:w-[360px] select-input-dropdow-wrapper
          ${
            isOpen
              ? "opacity-100 scale-100 pointer-events-auto"
              : "opacity-0 scale-95 pointer-events-none"
          }`}
          style={{ left: 0 }}
        >
          {isOpen && (
            <div className="absolute z-10 w-full hide-scrollbar select-input-dropdow-wrapper mt-1">
              <ul className="absolute flex z-10 flex-col space-y-4 my-1 w-[340px] max-h-[260px] hide-scrollbar overflow-scroll md:w-[360px] h-auto select-input-dropdown">
                {searchable && (
                  <li>
                    <div className="flex items-center px-3 py-1 rounded-full search-input-wrapper">
                      <SearchIcons className="w-5 h-5" />

                      <input
                        ref={searchInputRef}
                        className="w-full select-input-search-input"
                        placeholder="Search"
                        value={searchQuery}
                        disabled={readOnly}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                  </li>
                )}

                {filteredOptions.length > 0 ? (
                  filteredOptions.map((option) => (
                    <li
                      key={option.id || option.value}
                      className={`flex items-center justify-between cursor-pointer select-input-item
                      ${
                        option.id === value?.id
                          ? "select-input-item-selected"
                          : ""
                      }`}
                      onClick={() => handleSelect(option)}
                    >
                      <div className="flex items-center space-x-3">
                        {showIcon && option.icon && (
                          <img
                            src={option.icon}
                            alt=""
                            className="w-7 h-7 rounded-full"
                          />
                        )}

                        <span>{option.label}</span>
                      </div>

                      {option.meta?.phonecode && (
                        <span>+({option.meta.phonecode})</span>
                      )}
                    </li>
                  ))
                ) : (
                  <li className="flex flex-col items-center py-6 text-center">
                    <EmptyCurrencyListIcons className="w-16 h-16" />
                    <p>No results found</p>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>
      )}

      {error && <span className="text-error-500 text-sm pl-1 pt-0.5">{error}</span>}
    </div>
  );
};

export default CommonDropdown;
